import { JunctionDirectusFilesFfbbsiteCategories } from '@/lib/directus';
import { AppConfig } from '@/utils/AppConfig';

export type HitAllResult = {
  id: string;
  title: string;
  content?: string;
  count?: number;
  thumbnail?: string;
  category?: string;
  categories?: string[];
  permalink?: string;
  type?: string;
  date_published?: string;
  thumbnailDefaultUrl?: string;
  thumbnailMediumUrl?: string;
  date?: string;
  duration_seconds?: number;
  featured?: boolean;
  description?: string;
  ffbbsite_asset_tag_parent?: string;
  ffbbsite_asset_type?: string;
  ffbbsite_asset_tag_child?: string;
  filesize?: string;
};

export type HitAsset = {
  id: string;
  uploaded_on: string;
  date_published?: string;
  title: string;
  category: JunctionDirectusFilesFfbbsiteCategories[];
  ffbbsite_asset_tag_parent?: string;
  ffbbsite_asset_type?: string;
  ffbbsite_asset_tag_child?: string;
  filesize?: string;
};

export type HitFaq = {
  id: string;
  question: string;
  answer: string;
  date_published?: string;
  category?: string;
};

export type HitJob = {
  id: string;
  contract_type?: string;
  contract_duration?: string;
  city?: string;
  job_start?: string;
  unit?: string;
  service?: string;
  title?: string;
  date_published?: string;
};

export type HitFormation = {
  id: string;
  title?: string;
  date_published?: string;
  domain?: string;
  theme?: string;
  mode?: string;
  duration_hours?: string;
  type?: string;
  formation_id?: string;
  formation_title?: string;
  formation_domain?: string;
  formation_theme?: string;
  formation_mode?: string;
  formation_duration_hours?: string;
  formation_image?: string;
  formation_thumbnail?: string;
  thumbnail?: string;
  image?: string;
  date_start?: string;
  date_end?: string;
  postal_code?: string;
  place?: string;
  reference?: string;
  subscribe_button?: string;
  subscribeBtn?: string;
  id_original_hash?: string;
  entity?: string;
};

export const INDEX_GLOBAL = AppConfig.searchIndexGlobal;
export const INDEX_PAGES = AppConfig.searchIndexPages;
export const INDEX_NEWS = AppConfig.searchIndexNews;
export const INDEX_PHOTOS = AppConfig.searchIndexPhotos;
export const INDEX_VIDEOS = AppConfig.searchIndexVideos;
export const INDEX_ASSETS = AppConfig.searchIndexAssets;
export const INDEX_FAQ = AppConfig.searchIndexFaq;
export const INDEX_JOBS = AppConfig.searchIndexJobs;
export const INDEX_FORMATIONS = AppConfig.searchIndexFormations;
export const HIT_PER_PAGE = 4;
